/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { debounce } from 'underscore';
import { CUSTOM_WIDGET_BUFFER_PUBLISH, CUSTOM_WIDGET_BUFFER_SAVE, CUSTOM_WIDGET_BUFFER_DELETE, CUSTOM_WIDGET_BUFFER_FETCH, CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH, CUSTOM_WIDGET_REVISION_FETCH, CUSTOM_WIDGET_BUFFER_UPGRADE, CUSTOM_WIDGET_CREATE, GLOBAL_WIDGET_DELETE, GLOBAL_WIDGET_FETCH, GLOBAL_WIDGET_RENAME, GLOBAL_WIDGET_UPGRADE, GLOBAL_WIDGET_PUBLISH, LAYOUT_CELL_EDIT_GLOBAL_GROUP, LAYOUT_DELETE, LAYOUT_MOVE_RENAME, LAYOUT_WIDGET_EDIT_CUSTOM_WIDGET, LAYOUT_WIDGET_EDIT_GLOBAL_WIDGET, LAYOUT_BUFFER_SAVE, LAYOUT_PUBLISH, TABS_FETCH, TAB_OPEN, TAB_UPDATE, TEMPLATE_BUFFER_CLONE, TEMPLATE_BUFFER_DELETE, TEMPLATE_BUFFER_FETCH, TEMPLATE_BUFFER_FETCH_BY_PATH, TEMPLATE_REVISION_FETCH, TEMPLATE_BUFFER_MOVE_RENAME, TEMPLATE_CREATE, TEMPLATE_OPEN_BY_PATH, TEMPLATE_BUFFER_PUBLISH, TEMPLATE_BUFFER_SAVE, TEMPLATE_SAVE_BY_PATH, UNIFIED_LAYOUT_FETCH, LAYOUT_REVISION_FETCH, FINDER_FILE_CREATE, FINDER_FILE_DELETE, FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE, FINDER_FILE_DUPLICATE_READ_ONLY, FINDER_FILE_DUPLICATE, FINDER_FOLDER_DELETE, FINDER_FILES_BULK_DELETE, FINDER_FOLDER_CONTENTS_BULK_DELETE, FINDER_FUNCTIONS_CREATE, FINDER_FUNCTIONS_CREATE_ENDPOINT, FINDER_PROJECTS_CREATE_RECEIVE, CODEMIRROR_OPTIONS_UPDATE, RAW_ASSET_BUFFER_FETCH, FINDER_THEMES_CREATE_RECEIVE, FINDER_THEMES_DUPLICATE_RECEIVE, RAW_ASSET_BUFFER_FETCH_BY_PATH, FINDER_CREATE_RAW_ASSET, FINDER_PROJECTS_DEPLOY_RECEIVE, APPLICATION_EDITOR_LOADED, TEMPLATE_BUFFER_SAVE_BY_PATH, CUSTOM_WIDGET_BUFFER_SAVE_BY_PATH, CUSTOM_WIDGET_SAVE_BY_PATH, RECEIVE_ATTRIBUTES_META } from 'DesignData/actions/ActionTypes';
import { LAYOUT, TEMPLATE, GLOBAL_GROUP, CUSTOM_WIDGET, GLOBAL_WIDGET, RAW_ASSET, LAYOUT_SOURCE, GETTING_STARTED } from 'DesignData/enums/DesignAssetTypes';
import { MYSQL } from 'DesignData/enums/AssetSources';
import { byName as TemplateTypes } from 'ContentUtils/constants/TemplateTypes';
import FinderFile from 'DesignData/models/finder/File';
import Tab from 'DesignData/models/Tab';
import TemplateBuffer from 'DesignData/models/TemplateBuffer';
import TemplateModel from 'DesignData/models/Template';
import CustomWidgetModel from 'DesignData/models/CustomWidget';
import { saveTabs, closeTab, updateTab, replaceTab, openTab, closeTabs, refreshTab, replaceNonActiveTabRedirects } from 'DesignData/actions/Tabs';
import { fetch as fetchUnfiedLayout } from 'DesignData/actions/UnifiedLayouts';
import { fetch as fetchCustomWidgetBuffer, fetchByPath as fetchCustomWidgetBufferByPath } from 'DesignData/actions/CustomWidgetBuffers';
import { fetch as fetchTemplateBuffer, fetchByPath as fetchTemplateBufferByPath } from 'DesignData/actions/TemplateBuffers';
import { fetch as fetchRawAsset, fetchByPath as fetchRawAssetByPath } from 'DesignData/actions/RawAssetBuffers';
import { getTemplateBuffer } from 'DesignData/selectors/templateBuffers';
import { makeGetCustomWidgetBuffer } from 'DesignData/selectors/customWidgetBuffers';
import { getLayout } from 'DesignData/selectors/layouts';
import { getIsFolderOpen, getIsHubspotFolder, makeGetAssetParentThemeFolderId, getFolderContentsById, getFile, getActiveThemeFolderId, makeGetAssetParentProjectFolderId } from 'DesignData/selectors/finder';
import { getThemeFolderIdFromUrlQueryString } from 'DesignData/lib/themes/themes';
import { getActiveAssetId, getPinnedTabs } from 'DesignData/selectors/app';
import { openDeeplyNestedFolder, fetchContents } from 'DesignData/actions/finder/Folders';
import { setActiveThemeFolderId } from 'DesignData/actions/finder/Themes';
import { fetchDefault } from 'DesignData/actions/finder/FileMapper';
import { revealInFinder } from 'DesignData/actions/finder/Selections';
import { getRawAsset } from 'DesignData/selectors/rawAssetBuffers';
import { getTabsById, getTabsOrder, getActiveTabId, getRedirectedTabs } from 'DesignData/selectors/tabs';
import { NOT_FOUND } from 'DesignData/enums/HttpStatusCodes';
import { setActiveProjectFolderId } from '../actions/finder/Projects';
const getAssetParentThemeFolderId = makeGetAssetParentThemeFolderId();
const getAssetParentProjectFolderId = makeGetAssetParentProjectFolderId();

const getAssetId = asset => {
  return asset.layoutId || asset.templateId || asset.globalWidgetId || asset.customWidgetId || asset.rawAssetId;
};
/**
 * Get asset selector for tab based on asset type
 * @param {Number} assetType
 */


function getAssetSelector(assetType) {
  switch (assetType) {
    case LAYOUT:
    case GLOBAL_GROUP:
      {
        return getLayout;
      }

    case TEMPLATE:
      {
        return getTemplateBuffer;
      }

    case CUSTOM_WIDGET:
      {
        return makeGetCustomWidgetBuffer();
      }

    case RAW_ASSET:
      {
        return getRawAsset;
      }

    default:
      return null;
  }
}

let currentTabs = null;
/**
 * Save tabs whenever they change (not including initial load upon fetch).
 *
 * @param {Function} getState
 * @param {Object} result
 * @param {Function} dispatch
 */

function saveTabsOnChanges(getState, result, dispatch) {
  const {
    tabs
  } = getState();

  if (currentTabs === null) {
    // This will occur when redux starts and gets the default state from the reducer.
    currentTabs = tabs;
  } else if (currentTabs !== tabs && result.type !== TABS_FETCH) {
    // You __must__ dispatch the save *after* updating the `currentTabs` reference
    // otherwise you'll have an infinite loop.
    currentTabs = tabs;
    dispatch(saveTabs());
  }
}

const saveTabsOnChangesDebounced = debounce(saveTabsOnChanges, 100);
let hasBackgroundDownloadBeenTriggered = false;
/**
 * Download assets of background tabs after initial TAB_OPEN (by router) is triggered.
 * This is for application startup and should run only once.
 *
 * @param {Function} getState
 * @param {Object} result
 * @param {Function} dispatch
 */

function downloadBackgroundTabAssetsOnLoad(getState, result, dispatch) {
  if (hasBackgroundDownloadBeenTriggered) return;
  if (result.type !== TABS_FETCH || !result.tabs) return;
  const state = getState();
  const activeTabId = getActiveTabId(state);
  const byId = getTabsById(state);
  const order = getTabsOrder(state);

  if (!order.length) {
    // No background tabs to load.
    hasBackgroundDownloadBeenTriggered = true;
    return;
  }

  const tabsToDownloadFor = order.filter(tabId => tabId !== activeTabId).map(tabId => byId[tabId]);
  const {
    layoutTabs,
    templateTabs,
    customWidgetTabs,
    rawAssetTabs
  } = tabsToDownloadFor.reduce((hash, tab) => {
    switch (tab.assetType) {
      case LAYOUT:
      case GLOBAL_GROUP:
        hash.layoutTabs.push(tab);
        break;

      case TEMPLATE:
        hash.templateTabs.push(tab);
        break;

      case CUSTOM_WIDGET:
        hash.customWidgetTabs.push(tab);
        break;

      case GLOBAL_WIDGET:
        hash.globalWidgetIds.push(tab);
        break;

      case RAW_ASSET:
        hash.rawAssetTabs.push(tab);
        break;

      default:
        break;
    }

    return hash;
  }, {
    layoutTabs: [],
    templateTabs: [],
    customWidgetTabs: [],
    globalWidgetIds: [],
    rawAssetTabs: []
  });
  const activeAssetId = getActiveAssetId(getState());

  const getFetchHandlerByIdOrPath = (fetch, fetchByPath) => {
    return ({
      id,
      editorOptions = {}
    }) => {
      if (activeAssetId === id) return;
      const {
        assetSource = null
      } = editorOptions;

      if (assetSource && assetSource !== MYSQL && typeof id === 'string') {
        dispatch(fetchByPath(id));
      } else {
        dispatch(fetch(id));
      }
    };
  };

  layoutTabs.forEach(({
    id
  }) => activeAssetId !== id && dispatch(fetchUnfiedLayout(id)));
  customWidgetTabs.forEach(getFetchHandlerByIdOrPath(fetchCustomWidgetBuffer, fetchCustomWidgetBufferByPath));
  templateTabs.forEach(getFetchHandlerByIdOrPath(fetchTemplateBuffer, fetchTemplateBufferByPath));
  rawAssetTabs.forEach(getFetchHandlerByIdOrPath(fetchRawAsset, fetchRawAssetByPath));
  hasBackgroundDownloadBeenTriggered = true;
}
/**
 * On tab open / tab asset update, ensure file is visible in finder
 * if it's the currently active file
 * @param {Object} getState
 * @param {Object} result
 * @param {Function} dispatch
 */


function revealInFinderOnActiveTabChange(getState, result, dispatch) {
  const state = getState();

  switch (result.type) {
    case TAB_OPEN:
    case TAB_UPDATE:
      {
        const {
          tab
        } = result;
        if (!tab) return;
        const assetSelector = getAssetSelector(tab.assetType);
        if (!assetSelector) return;
        const props = {
          assetId: tab.id
        };
        const tabAsset = assetSelector(state, props);
        if (!tabAsset) return;
        const getIsParentFolderOpen = getIsFolderOpen;
        const isParentFolderOpen = getIsParentFolderOpen(state, {
          folderId: tabAsset.folderId
        });
        const activeAssetId = getActiveAssetId(state);
        const isActive = activeAssetId === tab.id;

        if (isActive && tabAsset.folderId && !isParentFolderOpen) {
          dispatch(openDeeplyNestedFolder(tabAsset.folderId));
        }

        break;
      }

    default:
      break;
  }
}
/**
 * On an action to an asset that would affect the tabs, update the tabs accordingly
 * @param {Function} getState
 * @param {Object} result
 * @param {Function} dispatch
 */


function updateTabsOnAssetsChange(getState, result, dispatch) {
  const state = getState();
  const byId = getTabsById(state);

  switch (result.type) {
    case GLOBAL_WIDGET_UPGRADE:
      {
        const {
          customWidget
        } = result;
        if (!customWidget) return;
        const tab = new Tab({
          id: customWidget.id,
          assetType: CUSTOM_WIDGET,
          label: customWidget.name
        });
        dispatch(openTab(tab));
        break;
      }

    case CUSTOM_WIDGET_BUFFER_DELETE:
      {
        const tab = byId[result.customWidgetId];
        if (tab && !result.error) dispatch(closeTab(tab));
        break;
      }

    case CUSTOM_WIDGET_BUFFER_FETCH:
    case CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH:
    case CUSTOM_WIDGET_REVISION_FETCH:
      {
        const {
          customWidgetId,
          customWidget,
          error
        } = result;
        const tab = byId[customWidgetId];

        if (error && error.status === NOT_FOUND && tab) {
          dispatch(closeTab(tab, false));
          return;
        }

        if (!customWidget) return;
        if (tab) dispatch(updateTab(tab, {
          label: customWidget.name
        }));
        break;
      }

    case CUSTOM_WIDGET_BUFFER_UPGRADE:
      {
        const {
          customWidgetId,
          customWidget
        } = result;
        const tab = byId[customWidgetId];
        if (!customWidget) return;
        if (tab) dispatch(updateTab(tab, {
          label: customWidget.name
        }));
        break;
      }

    case CUSTOM_WIDGET_CREATE:
    case LAYOUT_WIDGET_EDIT_CUSTOM_WIDGET:
      {
        const {
          customWidget
        } = result;
        if (!customWidget) return;
        const tab = new Tab({
          assetType: CUSTOM_WIDGET,
          id: customWidget.id,
          label: customWidget.name
        });
        dispatch(openTab(tab));
        break;
      }

    case LAYOUT_CELL_EDIT_GLOBAL_GROUP:
      {
        const {
          globalGroup
        } = result;
        if (!globalGroup) return;
        const tab = new Tab({
          id: globalGroup.id,
          assetType: LAYOUT,
          label: globalGroup.label
        });
        dispatch(openTab(tab));
        break;
      }

    case LAYOUT_DELETE:
      {
        const {
          layoutId,
          deleted
        } = result;
        if (!deleted) return;
        const tab = byId[layoutId];
        if (tab) dispatch(closeTab(tab));
        break;
      }

    case LAYOUT_MOVE_RENAME:
      {
        const {
          layout
        } = result;
        if (!layout) return;
        const tab = byId[layout.id];
        if (tab) dispatch(updateTab(tab, {
          label: layout.label
        }));
        break;
      }

    case LAYOUT_WIDGET_EDIT_GLOBAL_WIDGET:
      {
        const {
          globalWidget
        } = result;
        if (!globalWidget) return;
        const tab = new Tab({
          assetType: GLOBAL_WIDGET,
          id: globalWidget.id,
          label: globalWidget.label
        });
        dispatch(openTab(tab));
        break;
      }

    case TEMPLATE_BUFFER_CLONE:
      {
        const {
          template
        } = result;
        const tab = new Tab({
          assetType: TEMPLATE,
          id: template.id,
          label: template.label,
          path: template.path
        });
        dispatch(openTab(tab));
        break;
      }

    case TEMPLATE_BUFFER_DELETE:
      {
        const tab = byId[result.templateId];
        if (tab && !result.error) dispatch(closeTab(tab));
        break;
      }

    case TEMPLATE_BUFFER_FETCH:
    case TEMPLATE_BUFFER_FETCH_BY_PATH:
    case TEMPLATE_REVISION_FETCH:
      {
        const {
          templateId,
          template,
          error
        } = result;
        const tab = byId[templateId];

        if (error && error.status === NOT_FOUND && tab) {
          dispatch(closeTab(tab, false));
          return;
        }

        if (tab && template) {
          const label = new TemplateBuffer(template).getLabel();
          dispatch(updateTab(tab, {
            label
          }));
        }

        break;
      }

    case TEMPLATE_BUFFER_MOVE_RENAME:
      {
        if (!result.template) return;
        const {
          templateId,
          template
        } = result;
        const tab = byId[templateId];
        if (tab) dispatch(updateTab(tab, {
          label: template.label
        }));
        break;
      }

    case TEMPLATE_CREATE:
      {
        const {
          template
        } = result;
        if (!template) return;
        const tab = new Tab({
          assetType: TEMPLATE,
          id: template.id,
          label: template.label
        });
        dispatch(openTab(tab));
        break;
      }

    case TEMPLATE_OPEN_BY_PATH:
      {
        const {
          template
        } = result;
        if (!template) return;
        const {
          label
        } = template;
        let tab;

        if (template.body && template.body.generated_from_layout_id) {
          tab = new Tab({
            assetType: LAYOUT,
            id: template.body.generated_from_layout_id,
            label
          });
        } else {
          tab = new Tab({
            assetType: TEMPLATE,
            id: template.id,
            label
          });
        }

        dispatch(openTab(tab));
        break;
      }

    case UNIFIED_LAYOUT_FETCH:
    case LAYOUT_REVISION_FETCH:
      {
        const {
          layoutId,
          layout,
          error
        } = result;
        const tab = byId[layoutId];

        if (error && error.status === NOT_FOUND && tab) {
          dispatch(closeTab(tab, false));
          return;
        }

        if (!layout) return;

        if (tab) {
          const {
            label,
            templateType
          } = layout;
          const isGlobalGroup = templateType === TemplateTypes.global_group.id;
          let {
            assetType
          } = tab;

          if (assetType !== LAYOUT_SOURCE) {
            assetType = isGlobalGroup ? GLOBAL_GROUP : LAYOUT;
          }

          dispatch(updateTab(tab, {
            label: isGlobalGroup ? label.split('/').pop() : label,
            assetType
          }));
        }

        break;
      }

    case GLOBAL_WIDGET_FETCH:
    case GLOBAL_WIDGET_RENAME:
      {
        const {
          globalWidgetId,
          globalWidget,
          error
        } = result;
        const tab = byId[globalWidgetId];

        if (error && error.status === NOT_FOUND && tab) {
          dispatch(closeTab(tab, false));
          return;
        }

        if (!globalWidget) return;
        if (tab) dispatch(updateTab(tab, {
          label: globalWidget.label
        }));
        break;
      }

    case GLOBAL_WIDGET_DELETE:
      {
        const {
          globalWidgetId,
          deleted
        } = result;
        if (!deleted) return;
        const tab = byId[globalWidgetId];
        if (tab) dispatch(closeTab(tab));
        break;
      }

    case FINDER_THEMES_DUPLICATE_RECEIVE:
    case FINDER_THEMES_CREATE_RECEIVE:
      {
        const {
          theme
        } = result;
        const themeFolder = getFolderContentsById(state, {
          folderId: theme.folderId
        });
        const themeFiles = themeFolder.files.map(file => getFile(state, {
          fileId: file
        }));
        const themeJsonFile = themeFiles.filter(file => file.name === 'theme.json')[0];

        if (themeJsonFile) {
          const tab = new Tab({
            assetType: RAW_ASSET,
            id: themeJsonFile.id
          });
          dispatch(openTab(tab));
        }

        break;
      }

    case FINDER_FILE_CREATE:
      {
        const {
          file,
          fileType,
          openNewTab
        } = result;
        if (!(file && openNewTab)) return;
        const tab = new Tab({
          assetType: FinderFile.getDesignAssetType(fileType),
          id: file.id
        });
        dispatch(openTab(tab));
        break;
      }

    case FINDER_FILE_DELETE:
      {
        const {
          fileId,
          deleted
        } = result;
        if (!deleted) return;
        const tab = byId[fileId];
        if (tab) dispatch(closeTab(tab));
        break;
      }

    case FINDER_FILES_BULK_DELETE:
      {
        const {
          results
        } = result;
        if (!results) return;
        const tabs = results.reduce((__tabs, __result) => {
          if (__result.succeeded) {
            __tabs.push(byId[__result.id]);
          }

          return __tabs;
        }, []).filter(Boolean);

        if (tabs.length) {
          dispatch(closeTabs(tabs));
        }

        break;
      }

    case FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE:
      {
        const {
          file
        } = result;
        if (!file) return;
        const tab = new Tab({
          assetType: TEMPLATE,
          id: file.id
        });
        dispatch(openTab(tab));
        return;
      }

    case FINDER_FILE_DUPLICATE:
    case FINDER_FILE_DUPLICATE_READ_ONLY:
      {
        const {
          file,
          fileType
        } = result;
        if (!file) return;
        const tab = new Tab({
          assetType: FinderFile.getDesignAssetType(fileType),
          id: file.id
        });
        dispatch(openTab(tab));
        return;
      }

    case FINDER_FOLDER_DELETE:
      {
        const {
          folderId,
          deleted
        } = result;
        if (!deleted) return;
        const {
          files = [],
          subfolders = []
        } = result.contents;
        const tabs = [folderId, ...files, ...subfolders].map(id => byId[id]).filter(Boolean);
        if (tabs.length) dispatch(closeTabs(tabs));
        break;
      }

    case FINDER_FOLDER_CONTENTS_BULK_DELETE:
      {
        const {
          files
        } = result;

        if (!(files || files.length)) {
          return;
        }

        const tabs = files.map(__result => byId[__result.id]).filter(Boolean);

        if (tabs.length) {
          dispatch(closeTabs(tabs));
        }

        break;
      }

    case CUSTOM_WIDGET_BUFFER_SAVE:
    case CUSTOM_WIDGET_BUFFER_SAVE_BY_PATH:
    case CUSTOM_WIDGET_SAVE_BY_PATH:
    case CUSTOM_WIDGET_BUFFER_PUBLISH:
    case GLOBAL_WIDGET_PUBLISH:
    case TEMPLATE_BUFFER_PUBLISH:
    case TEMPLATE_BUFFER_SAVE:
    case TEMPLATE_BUFFER_SAVE_BY_PATH:
    case TEMPLATE_SAVE_BY_PATH:
    case LAYOUT_BUFFER_SAVE:
    case LAYOUT_PUBLISH:
      {
        const assetId = getAssetId(result);
        const tab = byId[assetId];
        if (!tab) return;
        dispatch(updateTab(tab, {
          lastActiveAt: Date.now()
        }));
        break;
      }

    case CODEMIRROR_OPTIONS_UPDATE:
      {
        const tab = byId.settings;
        if (!tab) return;
        dispatch(updateTab(tab, {
          lastActiveAt: Date.now()
        }));
        break;
      }

    case RAW_ASSET_BUFFER_FETCH:
    case RAW_ASSET_BUFFER_FETCH_BY_PATH:
      {
        const {
          rawAssetId,
          rawAsset,
          error
        } = result;
        const tab = byId[rawAssetId];

        if (error && error.status === NOT_FOUND && tab) {
          dispatch(closeTab(tab, false));
          return;
        }

        if (!rawAsset) return;
        if (tab) dispatch(updateTab(tab, {
          label: rawAsset.label
        }));
        break;
      }

    case FINDER_CREATE_RAW_ASSET:
      {
        const {
          rawAsset
        } = result;
        if (!rawAsset) return;
        const tab = new Tab({
          assetType: RAW_ASSET,
          id: rawAsset.id
        });
        dispatch(openTab(tab));
        break;
      }

    default:
      break;
  }
}
/**
 * Changes needed for assets in theme folders.
 */


function updatesForThemes(getState, result, dispatch) {
  switch (result.type) {
    case TAB_OPEN:
      {
        const {
          tab
        } = result;
        if (!tab) break;
        const props = {
          assetId: tab.id
        };
        const state = getState();

        const revealThemeFolder = () => {
          const assetParentTfid = getAssetParentThemeFolderId(state, props);
          const activeTfid = getActiveThemeFolderId(state); // Ensure that the tfid query is cleared for non-theme assets

          if (!assetParentTfid) {
            // Only clear it if we have a discrepency in what we think the active theme folder is
            if (activeTfid !== getThemeFolderIdFromUrlQueryString()) {
              dispatch(setActiveThemeFolderId(null));
            }

            return;
          }

          dispatch(revealInFinder(tab.id, false));
        };

        if (getIsHubspotFolder(state, props)) {
          const req = dispatch(fetchDefault());
          req.then(revealThemeFolder);
        } else {
          revealThemeFolder();
        }

        break;
      }

    default:
      break;
  }
}
/**
 * Changes needed for serverless functions.
 */


function updatesForServerless(getState, result, dispatch) {
  switch (result.type) {
    // Fetch folder contents and open serverless.json file
    case FINDER_FUNCTIONS_CREATE:
      {
        const {
          folder,
          serverlessJson
        } = result;
        if (!folder || !serverlessJson) break;
        const folderContentsReq = dispatch(fetchContents(folder.id));
        if (!folderContentsReq) break;
        folderContentsReq.then(() => {
          const tab = new Tab({
            assetType: RAW_ASSET,
            id: serverlessJson.id
          });
          dispatch(openTab(tab));
        });
        break;
      }

    case FINDER_FUNCTIONS_CREATE_ENDPOINT:
      {
        const {
          serverlessJson,
          parentFolderId
        } = result;
        if (!serverlessJson) break;
        const folderContentsReq = dispatch(fetchContents(parentFolderId));
        if (!folderContentsReq) break;
        folderContentsReq.then(() => {
          const tab = new Tab({
            assetType: RAW_ASSET,
            id: serverlessJson.id
          });
          dispatch(openTab(tab));
        });
        break;
      }

    default:
      break;
  }
}
/**
 * Changes needed for projects.
 */


function updatesForProjects(getState, result, dispatch) {
  switch (result.type) {
    case APPLICATION_EDITOR_LOADED:
      {
        const state = getState();
        const activeTabId = getActiveTabId(state);
        const props = {
          assetId: activeTabId
        };
        const assetParentProjectId = getAssetParentProjectFolderId(state, props);

        if (assetParentProjectId) {
          dispatch(setActiveProjectFolderId(assetParentProjectId));
        }

        break;
      }
    // Fetch folder contents and open hsproject.json file

    case FINDER_PROJECTS_CREATE_RECEIVE:
      {
        const {
          folder,
          configJson
        } = result;
        const folderContentsReq = dispatch(fetchContents(folder.id));
        if (!folderContentsReq) break;
        folderContentsReq.then(() => {
          const tab = new Tab({
            assetType: RAW_ASSET,
            id: configJson.id
          });
          dispatch(openTab(tab));
        });
        break;
      }

    case FINDER_PROJECTS_DEPLOY_RECEIVE:
      {
        const {
          stagedFiles
        } = result;
        const state = getState();
        const tabsById = getTabsById(state);
        stagedFiles.forEach(stagedFile => {
          const stagedFileTab = tabsById[stagedFile.id];

          if (stagedFileTab) {
            dispatch(refreshTab(stagedFileTab));
          }
        });
        break;
      }

    case TAB_OPEN:
    case TAB_UPDATE:
      {
        const {
          tab,
          tabs
        } = result;
        if (!tab || !tabs) return;
        const state = getState();
        const activeTabId = getActiveTabId(state);
        const redirectedTabs = getRedirectedTabs(state);
        dispatch(replaceNonActiveTabRedirects(tabs, redirectedTabs, activeTabId));
        break;
      }

    default:
      break;
  }
}

const getAssetDataFromResult = result => {
  const {
    customWidget,
    template
  } = result;
  let asset;
  let assetType;

  if (customWidget) {
    asset = new CustomWidgetModel(customWidget);
    assetType = CUSTOM_WIDGET;
  } else if (template) {
    asset = new TemplateModel(template);
    assetType = TEMPLATE;
  }

  return {
    asset,
    assetType
  };
};
/**
 * Fix issues where both MYSQL (id) and non-MYSQL (path) resources both exist.
 * E.g. suppose the following are the same module:
 *  - /modules/12345
 *  - /modules/p/@hubspot/rich_text
 *
 * @param {Function} getState
 * @param {Object} result
 * @param {Function} dispatch
 */


function fixNonMysql(getState, result, dispatch) {
  switch (result.type) {
    case RAW_ASSET_BUFFER_FETCH:
    case RAW_ASSET_BUFFER_FETCH_BY_PATH:
    case TEMPLATE_BUFFER_FETCH:
    case TEMPLATE_BUFFER_FETCH_BY_PATH:
    case CUSTOM_WIDGET_BUFFER_FETCH:
    case CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH:
      {
        const {
          asset,
          assetType
        } = getAssetDataFromResult(result);
        if (!asset) break;
        const {
          id,
          legacyId,
          assetSource
        } = asset;
        if (!legacyId) break;
        const state = getState();
        const tabsById = getTabsById(state);
        if (!tabsById[legacyId]) break;
        const activeTabId = getActiveTabId(state);

        if (activeTabId === id) {
          // Active tab is dupe of background tab that has legacy id
          const oldTab = tabsById[legacyId];
          dispatch(closeTab(oldTab, false));
          break;
        }

        if (activeTabId === legacyId) {
          if (tabsById[id]) {
            // Active tab has legacy id with hollow dupe tab in background
            const newTab = tabsById[id];
            const oldTab = tabsById[legacyId];
            dispatch(replaceTab(oldTab, newTab));
            break;
          } // Active tab has legacy id - replace with hollow tab/route


          const oldTab = tabsById[legacyId];
          const label = asset.label || oldTab.label;
          const newTab = new Tab({
            id,
            assetType,
            label,
            editorOptions: {
              assetSource
            }
          });
          dispatch(replaceTab(oldTab, newTab));
          break;
        }

        if (tabsById[id] && tabsById[legacyId]) {
          // Background tabs: both legacy and hollow open
          const oldTab = tabsById[legacyId];
          dispatch(closeTab(oldTab, false));
          break;
        } // Background tabs: replace legacyId with new hollow tab


        const oldTab = tabsById[legacyId];
        const newTab = new Tab({
          id,
          assetType,
          label: asset.label,
          editorOptions: {
            assetSource
          }
        });
        dispatch(replaceTab(oldTab, newTab));
        break;
      }

    default:
      break;
  }
}
/**
 * Update pinned status of tabs on load after user settings response
 */


function updatePinnedTabs(getState, result, dispatch) {
  switch (result.type) {
    case RECEIVE_ATTRIBUTES_META:
      {
        const {
          pinnedTabs
        } = result.designManagerUserSettings;

        if (pinnedTabs && pinnedTabs.length) {
          const state = getState();
          const tabsById = getTabsById(state);
          pinnedTabs.forEach(pinnedTabId => {
            const existingTab = tabsById[pinnedTabId];

            if (existingTab && !existingTab.pinned) {
              // Update the pinned status of all open pinned tabs on load
              dispatch(updateTab(existingTab, {
                isPinned: true
              }));
            } else {
              // Pinned tabs that are not currently open on load. Need to open them
              // NOTE: we currently only support pinning the getting started tab
              if (pinnedTabId === 'gettingStarted') {
                dispatch(openTab(new Tab({
                  assetType: GETTING_STARTED,
                  id: pinnedTabId,
                  isPinned: true
                }), false));
              }
            }
          });
        }

        break;
      }

    case TAB_OPEN:
      {
        const {
          tab
        } = result; // Update the pinned status of newly opened tabs

        if (tab && !tab.isPinned) {
          const pinnedTabs = getPinnedTabs(getState());

          if (pinnedTabs.length && pinnedTabs.includes(tab.id)) {
            dispatch(updateTab(tab, {
              isPinned: true
            }));
          }
        }

        break;
      }

    default:
      break;
  }
}
/*
 * Export
 */


export default (({
  getState,
  dispatch
}) => next => action => {
  const result = next(action);
  updatePinnedTabs(getState, result, dispatch);
  saveTabsOnChangesDebounced(getState, result, dispatch);
  downloadBackgroundTabAssetsOnLoad(getState, result, dispatch);
  updateTabsOnAssetsChange(getState, result, dispatch);
  revealInFinderOnActiveTabChange(getState, result, dispatch);
  fixNonMysql(getState, result, dispatch);
  updatesForThemes(getState, result, dispatch);
  updatesForServerless(getState, result, dispatch);
  updatesForProjects(getState, result, dispatch);
  return result;
});